export default {"src":"/_next/static/media/camera.018d7451.svg","height":512,"width":512};